export const QUESTION_INTENT_PROFILES = [
    {
        id: 'daily',
        label: 'Quotidiano',
        description: 'Domande brevi, centratura del giorno, micro-rituali e orientamento pratico.',
        recommended_spread_slugs: ['single-card', 'daily-triad', 'past-present-future'],
        fallback_spread_slugs: ['situation-action-outcome'],
    },
    {
        id: 'clarity',
        label: 'Chiarezza',
        description: 'Nodi da mettere a fuoco senza aprire un quadro eccessivamente dispersivo.',
        recommended_spread_slugs: ['situation-action-outcome', 'past-present-future', 'horseshoe'],
        fallback_spread_slugs: ['single-card', 'celtic-cross'],
    },
    {
        id: 'timeline',
        label: 'Timeline',
        description: 'Domande su evoluzione, processi, fasi e sviluppo nel tempo.',
        recommended_spread_slugs: ['past-present-future', 'timeline', 'annual-wheel'],
        fallback_spread_slugs: ['horseshoe', 'life-cycle'],
    },
    {
        id: 'decision',
        label: 'Decisione',
        description: 'Bivi, alternative, costi, opportunità e confronto fra percorsi.',
        recommended_spread_slugs: ['decisione-critica', 'option-a-option-b', 'three-paths'],
        fallback_spread_slugs: ['causa-nodo-scelta-costo-esito', 'situation-action-outcome'],
    },
    {
        id: 'relationship',
        label: 'Relazione',
        description: 'Dinamiche di coppia, poli in tensione, confini e nuove connessioni.',
        recommended_spread_slugs: ['relationship-two-polarities', 'relationship-check-in', 'amore-dinamica-di-coppia'],
        fallback_spread_slugs: ['nuova-connessione', 'confine-relazionale'],
    },
    {
        id: 'shadow',
        label: 'Ombra',
        description: 'Materiale rimosso, attriti ripetitivi, ferite e potere represso.',
        recommended_spread_slugs: ['stesa-ombra', 'shadow-base', 'discesa-integrazione'],
        fallback_spread_slugs: ['catena-ferita-potere', 'specchio-di-lilith-lite'],
    },
    {
        id: 'healing',
        label: 'Guarigione',
        description: 'Ricomposizione, integrazione, risorse e gesti di cura simbolica.',
        recommended_spread_slugs: ['guarigione-interiore', 'shadow-base', 'guida-interiore'],
        fallback_spread_slugs: ['mind-body-spirit', 'discesa-integrazione'],
    },
    {
        id: 'spiritual',
        label: 'Spirituale',
        description: 'Vocazione, disciplina interiore, pratica rituale e orientamento evolutivo.',
        recommended_spread_slugs: ['mind-body-spirit', 'guida-interiore', 'percorso-spirituale'],
        fallback_spread_slugs: ['chiamata-iniziazione', 'tree-of-life'],
    },
    {
        id: 'yearly',
        label: 'Annuale',
        description: 'Visione lunga, cicli di dodici mesi, milestone e rilettura nel tempo.',
        recommended_spread_slugs: ['annual-wheel', 'life-cycle', 'timeline'],
        fallback_spread_slugs: ['past-present-future', 'horseshoe'],
    },
    {
        id: 'lilith',
        label: 'Lilith',
        description: 'Desiderio, ombra erotico-spirituale, maschera, catena e integrazione.',
        recommended_spread_slugs: ['specchio-di-lilith', 'specchio-di-lilith-lite', 'stesa-ombra'],
        fallback_spread_slugs: ['shadow-base', 'discesa-integrazione'],
    },
    {
        id: 'kabbalistic',
        label: 'Kabbalistico',
        description: 'Sephiroth, ponti simbolici, sentieri dominanti e letture strutturate sull’albero.',
        recommended_spread_slugs: ['tree-of-life', 'ponte-sephirotico', 'sentiero-dominante'],
        fallback_spread_slugs: ['annual-wheel', 'percorso-spirituale'],
    },
    {
        id: 'open',
        label: 'Aperto',
        description: 'Domande non ancora ben centrate o richieste che cercano prima un framing.',
        recommended_spread_slugs: ['single-card', 'past-present-future', 'situation-action-outcome'],
        fallback_spread_slugs: ['horseshoe', 'daily-triad'],
    },
];
export const QUESTION_INTENT_PROFILE_MAP = Object.fromEntries(QUESTION_INTENT_PROFILES.map((profile) => [profile.id, profile]));
//# sourceMappingURL=question-intents.js.map